module.exports = __webpack_public_path__ + "static/media/unsplash-3.2af341e9.jpg";